import { createSlice } from '@reduxjs/toolkit'

const initialAppInfosState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    totalAppInfosCount: 0,
    entities: null,
    entitiesForPanel: null,
    appInfoByID: undefined,
    lastError: null,
    internalError: null,
    stayOpen: true,
    batchResult: []
}
export const callTypes = {
    list: 'list',
    action: 'action'
}

export const AppInfoReducers = createSlice({
    name: 'app_infos',
    initialState: initialAppInfosState,
    reducers: {
        setOpen: (state) => {
            state.stayOpen = true
        },
        catchError: (state, action) => {
            state.lastError = `${action.type}: ${action.payload.error}`
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false
            } else {
                state.actionsLoading = false
            }
            state.stayOpen = true
        },
        catchBadRequest: (state, action) => {
            state.lastError = `${action.payload.error}`
            state.listLoading = false
            state.actionsLoading = false
            state.stayOpen = true
        },
        catchInternalError: (state, action) => {
            state.internalError = `${action.payload.error}`
            state.listLoading = false
            state.actionsLoading = false
            state.stayOpen = true
        },
        startCall: (state, action) => {
            state.lastError = null
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true
            } else {
                state.actionsLoading = true
            }
            state.stayOpen = true
        },
        // countAppInfos
        countAppInfosFetched: (state, action) => {
            const { totalAppInfosCount } = action.payload
            state.listLoading = false
            state.lastError = null
            state.totalAppInfosCount = totalAppInfosCount
            state.stayOpen = true
        },
        // getAppInfoById
        appInfoFetched: (state, action) => {
            state.actionsLoading = false
            state.appInfoByID = action.payload.appInfoByID
            state.lastError = null
            state.internalError = null
        },
        // findAppInfos
        appInfosFetched: (state, action) => {
            const { totalCount, entities } = action.payload
            state.listLoading = false
            state.lastError = null
            state.entities = entities
            state.totalCount = totalCount
            state.stayOpen = true
        },
        // findAppInfosForPanel
        appInfosForPanelFetched: (state, action) => {
            const { entitiesForPanel } = action.payload
            state.listLoading = false
            state.lastError = null
            state.entitiesForPanel = entitiesForPanel
            state.stayOpen = true
        },
        // createAppInfo
        appInfoCreated: (state, action) => {
            state.actionsLoading = false
            state.lastError = null
            state.entities.push(action.payload.appInfo)
            state.stayOpen = false
        },
        // updateAppInfo
        appInfoUpdated: (state, action) => {
            state.lastError = null
            state.actionsLoading = false
            state.stayOpen = false
            state.entities = state.entities.map(entity => {
                if (entity.id === action.payload.appInfo.info_id) {
                    return action.payload.appInfo
                }
                return entity
            })
        },
        // deleteAppInfo
        appInfoDeleted: (state, action) => {
            state.lastError = null
            state.actionsLoading = false
            state.entities = state.entities.filter(el => el.id !== action.payload.info_id)
        },
        // deleteAppInfos
        appInfosDeleted: (state, action) => {
            state.lastError = null
            state.actionsLoading = false
            state.stayOpen = false
            state.entities = state.entities.filter(
                el => !action.payload.ids.includes(el.id)
            )
        },
        // appInfosUpdateState
        appInfosStatusUpdated: (state) => {
            state.actionsLoading = true
            state.lastError = null
            state.stayOpen = true
        },
        // appInfosDeleteState
        appInfosDeletedState: (state) => {
            state.actionsLoading = true
            state.lastError = null
            state.stayOpen = true
        },
        // setBatchResultStatus
        setBatchResult: (state, action) => {
            state.batchResult.push(action.payload.data)
        },
        // batchActionsFinished
        batchActionsFinished: (state) => {
            state.actionsLoading = false
            state.lastError = null
            state.stayOpen = true
        },
        // setInitBatch
        reInitBatch: (state) => {
            state.actionsLoading = false
            state.internalError = null
            state.lastError = null
            state.stayOpen = true
            state.batchResult = []
        }
    }
})
